import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import FormField from 'lib/src/components/form/FormField';
import TextInput from '@components/form/TextInput';
import useFieldValidation from '@components/form/hooks/useFieldValidation';
import React from 'react';
import { ChallengeDescriptionSectionRequest } from 'src/types/shared/Challenge';

const VideoInput: React.FC<VideoInputProps> = ({
    value,
    onChange,
    handleDelete,
    handleMoveSection,
    index,
    shouldShowSortButton,
    canMoveUp,
    canMoveDown,
}) => {
    const [error] = useFieldValidation({
        name: `descriptionSections[${index}]`,
        value,
    });

    return (
        <div className="db-input video" key={index || undefined}>
            <label>Video Input</label>
            <div className={`input-container ${error ? 'error' : ''}`}>
                <FormField name={`descriptionSections[${index}]`} error={error}>
                    <label htmlFor={`videoInput-title-${index}`}>
                        Section title
                        <TextInput
                            name={`videoInput-title-${index}`}
                            value={value.title}
                            placeholder="Section title"
                            onChange={_onChange}
                        />
                    </label>
                    <div className="input-container">
                        <label htmlFor={`videoInput-subtitle-${index}`}>
                            Video title
                            <TextInput
                                name={`videoInput-subtitle-${index}`}
                                value={value.contents[0].title}
                                placeholder="Video title"
                                onChange={_onChange}
                            />
                        </label>
                        <label htmlFor={`videoInput-${index}`}>
                            Video URL
                            <TextInput
                                name={`videoInput-${index}`}
                                value={value.contents[0].content}
                                placeholder="Paste Video URL"
                                onChange={_onChange}
                            />
                        </label>
                    </div>
                    <ButtonRow>
                        {!!handleMoveSection && shouldShowSortButton && (
                            <>
                                <ActionButton
                                    type="button"
                                    onClick={() => handleMoveSection(index, -1)}
                                    color="grey"
                                    icon="chevron-up"
                                    disabled={!canMoveUp}
                                >
                                    Move up
                                </ActionButton>
                                <ActionButton
                                    type="button"
                                    onClick={() => handleMoveSection(index, 1)}
                                    color="grey"
                                    icon="chevron-down"
                                    disabled={!canMoveDown}
                                >
                                    Move down
                                </ActionButton>
                            </>
                        )}
                        {!!handleDelete && (
                            <ActionButton
                                type="button"
                                color="red"
                                onClick={() => handleDelete(index)}
                            >
                                Delete Section
                            </ActionButton>
                        )}
                    </ButtonRow>
                </FormField>
            </div>
        </div>
    );

    function _onChange(name: string, content: string) {
        if (name === `videoInput-${index}`)
            onChange(index, { ...value, contents: [{ ...value.contents[0], content }] });
        else if (name === `videoInput-title-${index}`)
            onChange(index, { ...value, title: content });
        else if (name === `videoInput-subtitle-${index}`)
            onChange(index, { ...value, contents: [{ ...value.contents[0], title: content }] });
    }
};

interface VideoInputProps {
    value: ChallengeDescriptionSectionRequest;
    onChange: (index: number, newData: ChallengeDescriptionSectionRequest) => void;
    handleDelete?: (index: number) => void;
    handleMoveSection?: (index: number, moveBy: number) => void;
    index: number;
    shouldShowSortButton: boolean;
    API_URL?: string;
    S3_URL?: string;
    canMoveUp: boolean;
    canMoveDown: boolean;
}

export default VideoInput;
